export default {
    loadInitials: function () {
        return {
            loader: 0,
            environment: ``,
            user: {
                authenticated: false,
                details: null,
                error: null,
                isSuperUser: false
            },
            customers: null,
            vehicle: null,
            culture: null
        };
    }
};
